import { g as getDocument, n as nextTick, S as Swiper, N as Navigation, P as Pagination } from "./pagination.chunk.js";
const atcWrapper = document.querySelector(".jc-atc-btn");
const stickyAtcWrapper = document.querySelector(".js-sticky-atc");
let options = {
  rootMargin: "0px"
};
const callbackAtcBtn = (entries, observer) => {
  entries.forEach((entrie) => {
    if (entrie.isIntersecting) {
      document.body.style.paddingBottom = "0";
      stickyAtcWrapper.style.opacity = "";
      stickyAtcWrapper.style.visibility = "";
    } else {
      document.body.style.paddingBottom = stickyAtcWrapper.scrollHeight + "px";
      stickyAtcWrapper.style.opacity = "1";
      stickyAtcWrapper.style.visibility = "visible";
    }
  });
};
const observerBtnAtc = new IntersectionObserver(callbackAtcBtn, options);
if (stickyAtcWrapper) {
  observerBtnAtc.observe(atcWrapper);
}
function Autoplay({
  swiper,
  extendParams,
  on,
  emit
}) {
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3e3,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = false;
      swiper.autoplay.paused = false;
      return;
    }
    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr("data-swiper-autoplay")) {
      delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
    }
    clearTimeout(timeout);
    timeout = nextTick(() => {
      let autoplayResult;
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit("autoplay");
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit("autoplay");
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit("autoplay");
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit("autoplay");
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit("autoplay");
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit("autoplay");
      } else {
        stop();
      }
      if (swiper.params.cssMode && swiper.autoplay.running)
        run();
      else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }
  function start() {
    if (typeof timeout !== "undefined")
      return false;
    if (swiper.autoplay.running)
      return false;
    swiper.autoplay.running = true;
    emit("autoplayStart");
    run();
    return true;
  }
  function stop() {
    if (!swiper.autoplay.running)
      return false;
    if (typeof timeout === "undefined")
      return false;
    if (timeout) {
      clearTimeout(timeout);
      timeout = void 0;
    }
    swiper.autoplay.running = false;
    emit("autoplayStop");
    return true;
  }
  function pause(speed) {
    if (!swiper.autoplay.running)
      return;
    if (swiper.autoplay.paused)
      return;
    if (timeout)
      clearTimeout(timeout);
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ["transitionend", "webkitTransitionEnd"].forEach((event) => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }
  function onVisibilityChange() {
    const document2 = getDocument();
    if (document2.visibilityState === "hidden" && swiper.autoplay.running) {
      pause();
    }
    if (document2.visibilityState === "visible" && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl)
      return;
    if (e.target !== swiper.$wrapperEl[0])
      return;
    ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;
    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }
  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit("autoplayPause");
      pause();
    }
    ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }
  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }
    swiper.autoplay.paused = false;
    emit("autoplayResume");
    run();
  }
  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on("mouseenter", onMouseEnter);
      swiper.$el.on("mouseleave", onMouseLeave);
    }
  }
  function detachMouseEvents() {
    swiper.$el.off("mouseenter", onMouseEnter);
    swiper.$el.off("mouseleave", onMouseLeave);
  }
  on("init", () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document2 = getDocument();
      document2.addEventListener("visibilitychange", onVisibilityChange);
      attachMouseEvents();
    }
  });
  on("beforeTransitionStart", (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on("sliderFirstMove", () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on("touchEnd", () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on("destroy", () => {
    detachMouseEvents();
    if (swiper.autoplay.running) {
      stop();
    }
    const document2 = getDocument();
    document2.removeEventListener("visibilitychange", onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}
function effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on("beforeInit", () => {
    if (swiper.params.effect !== effect)
      return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on("setTranslate", () => {
    if (swiper.params.effect !== effect)
      return;
    setTranslate();
  });
  on("setTransition", (_s, duration) => {
    if (swiper.params.effect !== effect)
      return;
    setTransition(duration);
  });
  on("transitionEnd", () => {
    if (swiper.params.effect !== effect)
      return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows)
        return;
      swiper.slides.each((slideEl) => {
        const $slideEl = swiper.$(slideEl);
        $slideEl.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
      });
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on("virtualUpdate", () => {
    if (swiper.params.effect !== effect)
      return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}
function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      "backface-visibility": "hidden",
      "-webkit-backface-visibility": "hidden"
    });
  }
  return $slideEl;
}
function effectVirtualTransitionEnd({
  swiper,
  duration,
  transformEl,
  allSlides
}) {
  const {
    slides,
    activeIndex,
    $wrapperEl
  } = swiper;
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let $transitionEndTarget;
    if (allSlides) {
      $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
    } else {
      $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
    }
    $transitionEndTarget.transitionEnd(() => {
      if (eventTriggered)
        return;
      if (!swiper || swiper.destroyed)
        return;
      eventTriggered = true;
      swiper.animating = false;
      const triggerEvents = ["webkitTransitionEnd", "transitionend"];
      for (let i = 0; i < triggerEvents.length; i += 1) {
        $wrapperEl.trigger(triggerEvents[i]);
      }
    });
  }
}
function EffectFade({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    fadeEffect: {
      crossFade: false,
      transformEl: null
    }
  });
  const setTranslate = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = swiper.slides.eq(i);
      const offset = $slideEl[0].swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate)
        tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.css({
        opacity: slideOpacity
      }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
    }
  };
  const setTransition = (duration) => {
    const {
      transformEl
    } = swiper.params.fadeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };
  effectInit({
    effect: "fade",
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
document.querySelectorAll(".jc-swiper-steps").forEach((swiper) => {
  new Swiper(`#${swiper.id}`, {
    modules: [Navigation],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 12,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32
      },
      992: {
        slidesPerView: 3
      }
    }
  });
});
document.querySelectorAll(".jc-swiper-reviews").forEach((swiper) => {
  new Swiper(`#${swiper.id}`, {
    modules: [Navigation],
    navigation: {
      nextEl: ".reviewsSwiper-button-next",
      prevEl: ".reviewsSwiper-button-prev"
    },
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      640: {
        slidesPerView: 2.1
      },
      992: {
        slidesPerView: 2.5
      },
      1024: {
        slidesPerView: 1.8
      },
      1280: {
        slidesPerView: 2.5
      }
    }
  });
});
document.querySelectorAll(".swiper-recommendation-togglers").forEach(
  (swiper) => {
    new Swiper(`#${swiper.id}`, {
      slidesPerView: "auto",
      spaceBetween: 8,
      breakpoints: {
        1024: {
          slidesPerView: 4
        }
      }
    });
  }
);
const togglers = document.querySelectorAll("[data-switchable-section_toggler-id]");
const sectionsAll = Array.from(document.querySelectorAll("[data-switchable-section_id]"));
const closeSectionAll = (wrapper) => {
  wrapper.querySelectorAll("[data-switchable-section_toggler-id]").forEach(({ classList }) => classList.remove("active-toggler"));
  wrapper.querySelectorAll("[data-switchable-section_id]").forEach(({ classList }) => classList.remove("jc-flex"));
  wrapper.querySelectorAll("[data-switchable-section_id]").forEach(({ classList }) => classList.add("jc-hidden"));
};
togglers.forEach((item) => {
  item.addEventListener("click", () => {
    const tabWrapper = item.closest(".shopify-section");
    const sectionId = item.getAttribute("data-switchable-section_toggler-id");
    const currentSections = sectionsAll.filter(
      (section) => section.getAttribute("data-switchable-section_id") === sectionId
    );
    const openSection = () => {
      item.classList.add("active-toggler");
      currentSections.forEach(({ classList }) => classList.remove("jc-hidden"));
      currentSections.forEach(({ classList }) => classList.add("jc-flex"));
    };
    closeSectionAll(tabWrapper);
    openSection();
  });
});
class JCVideoComponent extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector(".jc-video");
    this.buttonPlay = this.querySelector(".jc-video-play");
    this.togglePlay = this.togglePlay.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }
  connectedCallback() {
    const options2 = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
    };
    this.observer = new IntersectionObserver(this.handleIntersection, options2);
    if (this.buttonPlay) {
      this.buttonPlay.addEventListener("click", this.togglePlay);
    }
    this.observer.observe(this.video);
  }
  togglePlay() {
    if (!this.buttonPlay.classList.contains("is-play")) {
      this.buttonPlay.classList.add("is-play");
      this.video.play();
    } else {
      this.buttonPlay.classList.remove("is-play");
      this.video.pause();
    }
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.video && entry.target.classList.contains("autoplay")) {
        if (entry.isIntersecting) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = this.buttonPlay) == null ? void 0 : _a.removeEventListener("click", this.togglePlay);
    this.observer.disconnect();
  }
}
customElements.define("jolly-video", JCVideoComponent);
function accordion(config) {
  const defaultConfig = {
    accordionsGroupSelector: "[data-accordions-group]",
    accordionSelector: "[data-accordion]",
    accordionHeaderSelector: "[data-accordion-header]",
    accordionBodySelector: "[data-accordion-body]",
    accordionContentBodySelector: "[data-accordion-content-body]",
    accordionOpenByDefaultAttribute: "data-accordion-open-by-default",
    accordionOpenFirstByDefault: false,
    accordionActiveClassName: "accordion_active",
    animationDuration: 300,
    // in ms,
    autoClose: true
  };
  const animationDurationCSSVariable = "--accordion-animation-duration";
  const {
    accordionsGroupSelector,
    accordionSelector,
    accordionHeaderSelector,
    accordionBodySelector,
    accordionContentBodySelector,
    accordionOpenByDefaultAttribute,
    accordionOpenFirstByDefault,
    accordionActiveClassName,
    animationDuration,
    autoClose
  } = { ...defaultConfig, ...config ?? {} };
  const accordionsGroupCollection = document.querySelectorAll(accordionsGroupSelector);
  accordionsGroupCollection.forEach((accordionGroup) => {
    accordionGroup.style.setProperty(`${animationDurationCSSVariable}`, `${animationDuration}ms`);
    const accordions2 = accordionGroup.querySelectorAll(accordionSelector);
    const controls = Array.from(accordions2).map((accordion2, idx) => {
      const header2 = accordion2.querySelector(accordionHeaderSelector);
      const body = accordion2.querySelector(accordionBodySelector);
      const contentBody = accordion2.querySelector(accordionContentBodySelector);
      body.style.overflow = "hidden";
      body.style.transitionProperty = "height";
      body.style.transitionDuration = `var(${animationDurationCSSVariable})`;
      const accordionControls = new class {
        constructor() {
          this._resizeObserver = new ResizeObserver(() => {
            this.open();
          });
          this._header = header2;
          this._isOpen = false;
          accordion2.hasAttribute(accordionOpenByDefaultAttribute) || accordionOpenFirstByDefault && idx === 0 ? this.open() : this.close();
        }
        get isOpen() {
          return this._isOpen;
        }
        set isOpen(isOpen) {
          this._isOpen = isOpen;
          if (isOpen) {
            this._resizeObserver.observe(contentBody);
            accordion2.classList.add(accordionActiveClassName);
          } else {
            this._resizeObserver.unobserve(contentBody);
            accordion2.classList.remove(accordionActiveClassName);
          }
        }
        get header() {
          return this._header;
        }
        open() {
          body.style.height = `${contentBody.offsetHeight}px`;
          this.isOpen = true;
        }
        close() {
          body.style.height = "0";
          this.isOpen = false;
        }
      }();
      return accordionControls;
    });
    const closeAll = () => controls.forEach((control) => control.close());
    controls.forEach((control) => {
      control.header.addEventListener("click", () => {
        const isOpen = control.isOpen;
        if (autoClose) {
          closeAll();
        }
        isOpen ? control.close() : control.open();
      });
    });
  });
}
accordion({ accordionOpenFirstByDefault: true });
const menuToggle = document.querySelector(".jc-menu-toggle");
const mobileMenu = document.querySelector(".jc-menu");
const menuMobile = document.querySelectorAll(".jc-mobile-menu");
const header = document.querySelector(".jolly-header");
document.querySelector(".announcement-bar");
menuMobile.forEach((menu) => {
  const menuLinks = menu.querySelectorAll(".jc-mobile-menu-link");
  const menuBackBtn = menu.querySelectorAll(".jc-mobile-back");
  menuLinks.forEach((menuLink) => {
    menuLink.addEventListener("click", (e) => {
      e.preventDefault();
      menuLink.closest(".jc-mobile-menu-item").querySelector(".jc-mobile-submenu").classList.remove("jc-invisible");
      mobileMenu.style.top = "0px";
    });
    menuBackBtn.forEach((backBtn) => {
      backBtn.addEventListener("click", () => {
        backBtn.closest(".jc-mobile-submenu").classList.add("jc-invisible");
        mobileMenu.style.top = header.offsetHeight + "px";
      });
    });
  });
});
document.querySelectorAll(".jc-menu-hide").forEach((menuHide) => {
  menuHide.addEventListener("click", () => {
    document.querySelector(".jc-menu-toggle").click();
    menuHide.closest(".jc-mobile-submenu").classList.add("jc-invisible");
    menuHide.closest(".jc-mobile-submenu").querySelector(".jc-mobile-back").click();
  });
});
menuToggle.addEventListener("click", function() {
  if (mobileMenu.classList.contains("active")) {
    mobileMenu.classList.remove("active");
    header.style.position = "";
    document.body.classList.remove("jc-overflow-hidden");
  } else {
    mobileMenu.classList.add("active");
    header.style.position = "fixed";
    document.body.classList.add("jc-overflow-hidden");
  }
  this.classList.toggle("active");
  trackScrollDistance();
});
const accordions = document.querySelectorAll(".jc-mobile-submenu");
accordions.forEach((accordion2) => {
  let accordionItems = accordion2.querySelectorAll(".jc-mobile-accordion-control");
  accordionItems.forEach((accordion3) => {
    accordion3.addEventListener("click", () => {
      let content = accordion3.nextElementSibling;
      if (window.innerWidth <= 1023) {
        accordion3.classList.toggle("active");
        if (accordion3.classList.contains("active")) {
          content.style.height = content.scrollHeight + "px";
        } else {
          content.style.height = 0;
        }
      }
    });
  });
});
window.addEventListener("DOMContentLoaded", trackScrollDistance);
function trackScrollDistance() {
  if (header) {
    let mobileMenuTop = header.offsetHeight;
    mobileMenu.style.top = mobileMenuTop + "px";
  }
}
document.querySelector(".jc-menu").addEventListener("click", function(e) {
  if (e.target === e.currentTarget) {
    e.currentTarget.classList.remove("active");
  }
});
document.querySelector(".jc-menu--inner").addEventListener("click", function(e) {
  e.stopPropagation();
});
document.addEventListener("click", modalHandler);
const htmlBody = document.querySelector("body");
function modalHandler(evt) {
  const backdrop = document.querySelector("#modal-backdrop");
  const modalBtnOpen = evt.target.closest(".js-modal");
  if (modalBtnOpen) {
    const modalSelector = modalBtnOpen.dataset.modal;
    showModal(document.querySelector(modalSelector), backdrop);
  }
  const modalBtnClose = evt.target.closest(".js-modal-close");
  if (modalBtnClose) {
    evt.preventDefault();
    hideModal(modalBtnClose.closest(".modal-window"), backdrop);
  }
  if (evt.target.matches("#modal-backdrop")) {
    hideModal(document.querySelector(".modal-window.show"), backdrop);
  }
}
function showModal(modalElem, backdrop) {
  modalElem.classList.add("show");
  backdrop.classList.remove("!jc-hidden");
  htmlBody.classList.add("jc-overflow-hidden");
}
function hideModal(modalElem, backdrop) {
  modalElem.classList.remove("show");
  backdrop.classList.add("!jc-hidden");
  htmlBody.classList.remove("jc-overflow-hidden");
}
class announcementBar extends HTMLElement {
  constructor() {
    super();
    this.swiper = this.querySelector(".swiper");
    if (!this.swiper)
      return;
    const delay = this.swiper.dataset.delay;
    this.autoplayDelay = parseInt(delay, 10);
    if (isNaN(this.autoplayDelay)) {
      this.autoplayDelay = 3e3;
    }
  }
  connectedCallback() {
    new Swiper(`#${this.swiper.id}`, {
      modules: [EffectFade, Autoplay],
      speed: 500,
      loop: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: this.autoplayDelay,
        disableOnInteraction: false
      },
      freeMode: true
    });
  }
}
customElements.define("g-announcement-bar", announcementBar);
document.querySelectorAll(".swiper-reviews").forEach((swiper) => {
  new Swiper(`#${swiper.id}`, {
    modules: [Pagination],
    slidesPerView: "auto",
    spaceBetween: 8,
    pagination: {
      el: ".swiper-reviews-pagination",
      clickable: true
    }
  });
});
document.querySelectorAll(".swiper-featured-reviews").forEach((swiper) => {
  new Swiper(`#${swiper.id}`, {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-featured-reviews-pagination",
      clickable: true
    },
    breakpoints: {
      480: {
        centeredSlides: false
      }
    }
  });
});
const checkCustomerEmailButton = document.getElementById("CheckCustomerEmailButton");
const checkCustomerEmailInput = document.getElementById("CheckCustomerEmail");
if (checkCustomerEmailButton) {
  checkCustomerEmailButton.addEventListener("click", () => {
    const email = checkCustomerEmailInput.value;
    if (!validateEmail(checkCustomerEmailInput, email))
      return;
    setCookie("UserLogInInfo", JSON.stringify({ "customers": [{ "email": `${email}` }] }), 7);
    searchUser(email).then((val) => {
      switchLoginRegister(val);
      if (val.customers[0] == void 0) {
        setCookie("UserLogInInfo", JSON.stringify({ "customers": [{ "email": `${customer_email}` }] }), 7);
      } else {
        setCookie("UserLogInInfo", JSON.stringify(val), 7);
      }
    });
  });
}
if (window.location.pathname.indexOf("/account/login") != -1) {
  eraseCookie("UserLogInInfo");
}
if (window.location.pathname.indexOf("/account/register") != -1) {
  window.addEventListener("load", () => {
    const userData = JSON.parse(getCookie("UserLogInInfo"));
    if (userData) {
      document.getElementById("RegisterForm-email").value = userData.customers[0].email;
    }
  });
}
async function searchUser(customer_email2) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  var urlencoded = new URLSearchParams();
  urlencoded.append("email", customer_email2);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
    mode: "cors"
  };
  let renderCall = await fetch("https://jolly-render-services.onrender.com/maisonhadenn/getuserinfo", requestOptions);
  if (!renderCall.ok) {
    console.error("Bad render call");
    return {};
  }
  let responce = await renderCall.json();
  return responce.userData;
}
function switchLoginRegister(data) {
  console.log(data);
  if (data == void 0) {
    window.location.href = "/account/register";
  } else if (data.customers[0].state == "enabled") {
    document.querySelector(".customer.login").classList.remove("jc-hidden");
    document.querySelector(".customer.redirect").classList.add("jc-hidden");
    document.getElementById("CustomerEmail").value = data.customers[0].email;
  } else {
    window.location.href = data.customers[0].link;
  }
}
function validateEmail(emailField, email) {
  var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/;
  if (email.match(mailformat)) {
    emailField.classList.remove("error");
    return true;
  } else {
    emailField.focus();
    emailField.classList.add("error");
    return false;
  }
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = /* @__PURE__ */ new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ")
      c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0)
      return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
